export const fmt = (n) =>
  new Intl.NumberFormat("tr-TR", { maximumFractionDigits: 1 }).format(n ?? 0);

export const STATUS = {
  kritik: { label: "Kritik", color: "#EF4444", bg: "rgba(239,68,68,0.12)", border: "rgba(239,68,68,0.4)" },
  uyari: { label: "Uyarı", color: "#F59E0B", bg: "rgba(245,158,11,0.12)", border: "rgba(245,158,11,0.4)" },
  guvenli: { label: "Güvenli", color: "#10B981", bg: "rgba(16,185,129,0.12)", border: "rgba(16,185,129,0.4)" },
};

export const PO_STATUS = {
  bekliyor: { label: "Bekliyor", color: "#F59E0B" },
  kismi: { label: "Kısmi Teslim", color: "#0EA5E9" },
  teslim_alindi: { label: "Teslim Alındı", color: "#10B981" },
  kapali: { label: "Kapatıldı", color: "#64748B" },
};

export const REORDER = {
  acil: { label: "ACİL SİPARİŞ", color: "#EF4444" },
  planli: { label: "Planlı Sipariş", color: "#F59E0B" },
  gerek_yok: { label: "Gerek Yok", color: "#10B981" },
};

export const MAT_TYPE = {
  tel: { label: "Tel", color: "#94A3B8" },
  tela: { label: "Tela", color: "#8B5CF6" },
  kraft: { label: "Kraft Kağıt", color: "#D97706" },
  lamet: { label: "Lamet", color: "#0EA5E9" },
  cring: { label: "C-Ring", color: "#EC4899" },
  holtmelt: { label: "Holtmelt", color: "#F97316" },
  celik_cember: { label: "Çelik Çember", color: "#64748B" },
  tahta_palet: { label: "Tahta Palet", color: "#A16207" },
  round_frame: { label: "Round Frame", color: "#14B8A6" },
};

// Otomatik tüketimi olmayan; stok ve tüketim elle yönetilen türler
export const MANUAL_TYPES = ["holtmelt", "celik_cember", "tahta_palet", "round_frame"];

export const EXTRA_TYPE_TABS = [
  { key: "holtmelt", label: "Holtmelt" },
  { key: "celik_cember", label: "Çelik Çember" },
  { key: "tahta_palet", label: "Tahta Palet" },
  { key: "round_frame", label: "Round Frame" },
];

export const MACHINE_GROUPS = {
  Dizgi: Array.from({ length: 5 }, (_, i) => `Dizgi ${i + 1}`),
  Bonnel: Array.from({ length: 14 }, (_, i) => `Bonnel ${i + 1}`),
  Tablet: Array.from({ length: 4 }, (_, i) => `Tablet ${i + 1}`),
};
export const ALL_MACHINES = [
  ...MACHINE_GROUPS.Dizgi, ...MACHINE_GROUPS.Bonnel, ...MACHINE_GROUPS.Tablet,
];
export const DAYS = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];

// Tela: metre -> kg (gramaj g/m² × en cm × metre / 100000) ve top/rulo gösterimi
export const telaKg = (meters, mat) => {
  const g = mat?.gramaj, w = mat?.width;
  if (!g || !w) return null;
  return (meters || 0) * g * w / 100000;
};
export const telaTopKg = (meters, mat) => {
  const kg = telaKg(meters, mat);
  const rl = mat?.roll_length;
  const parts = [];
  if (rl) parts.push(`${fmt((meters || 0) / rl)} ROLL`);
  if (kg != null) parts.push(`${fmt(kg)} KG`);
  return parts.length ? parts.join(" / ") : null;
};
